import dayjs from 'dayjs'

const advancedTrackingFormat = (userId, source, element, elementInfo) => {
  let eInfo = ''
  const valueToM = 23571113
  const mUserId = parseInt(userId, 10) + valueToM
  if (elementInfo) {
    eInfo = `, "ElementInfo": "${elementInfo}"`
  }
  return `"UserId": "${mUserId}", "Date": "${dayjs().format('YYYY-MM-DD')}", "Time": "${dayjs().format('hh:mm')
  }", "Source": "${source}", "Element": "${element}"${eInfo}`
}

export default advancedTrackingFormat
